export default __webpack_public_path__ + "static/media/icon_detalles.a1fbba3d.svg";